import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleAccessService {
  objRole: RoleAccess = new RoleAccess();
  constructor(private router: Router) {
  if (!this.objRole) {
    const userData = localStorage.getItem("user-data");

    if (!userData || userData === "undefined" || userData === "null") {
      this.forceLogout();
      return;
    }
    try {
      this.setRoleData(JSON.parse(userData));
    } catch (e) {
      console.error("Invalid user-data in localStorage", e);
      this.forceLogout();
    }
  }
}

private forceLogout() {
  localStorage.clear();
  this.router.navigate(['/']).then(() => {
    window.location.reload();
  });
}
  setRoleData(data: any) {
    this.objRole.ROLE = data["ROLE"];
    this.objRole.SECURELVL = data["SECURELVL"];
    this.objRole.ADMINROLE = data["ADMINROLE"];
    this.objRole.CAPTURE = data["CAPTURE"];
    this.objRole.GALLERY = data["GALLERY"];
    this.objRole.UPCOMING_EVENTS = data["UPCOMING_EVENTS"];
    this.objRole.NEWS = data["NEWS"];
    this.objRole.REPORTS = data["REPORTS"];
    this.objRole.KITS_KIQS = data["KITS_KIQS"];
    this.objRole.CONGRESS = data["CONGRESS"];
    this.objRole.CHAT = data["CHAT"];
    this.objRole.VIEWCHAT = data["VIEWCHAT"];
    this.objRole.EXPORT = data["EXPORT"];
    this.objRole.MYDEFALULT = data["MYDEFALULT"];
    this.objRole.DM = data["DM"];
    this.objRole.CONGRESS_ADMIN = data["CONGRESS_ADMIN"];
    this.objRole.CLINICAL_TRIALS = data["CLINICAL_TRIALS"];
    this.objRole.PRODUCT = data["PRODUCT"];
    this.objRole.TIMELINES = data["TIMELINES"];
    this.objRole.NEWSLETTER = data["NEWSLETTER"];
    this.objRole.WORKSHOP = data["WORKSHOP"];
    this.objRole.AT_A_GLANCE = data["AT_A_GLANCE"];
    this.objRole.ECHO = data["ECHO"];
    //console.log(this.objRole)
  }
  reset() {
    if (localStorage.getItem("user-data")) {
      this.setRoleData(JSON.parse(localStorage.getItem("user-data")));
    }
  }
  IsExportAccess() {
    if (!this.objRole.EXPORT) {
      this.reset();
      return this.objRole.EXPORT == "1" ? true : false;
    } else {
      return this.objRole.EXPORT == "1" ? true : false;
    }
  }
  IsReportAccess() {
    if (!this.objRole.REPORTS) {
      this.reset();
      return this.objRole.REPORTS == "1" ? true : false;
    } else {
      return this.objRole.REPORTS == "1" ? true : false;
    }
  }
  IsGalleryAccess() {
    if (!this.objRole.GALLERY) {
      this.reset();
      return this.objRole.GALLERY == "1" ? true : false;
    } else {
      return this.objRole.GALLERY == "1" ? true : false;
    }
  }
  IsNewsAccess() {
    if (!this.objRole.NEWS) {
      this.reset();
      return this.objRole.NEWS == "1" ? true : false;
    } else {
      return this.objRole.NEWS == "1" ? true : false;
    }
  }
  IsNewsLetterAccess() {
    if (!this.objRole.NEWSLETTER) {
      this.reset();
      return this.objRole.NEWSLETTER == "1" ? true : false;
    } else {
      return this.objRole.NEWSLETTER == "1" ? true : false;
    }
  }

  IsEchoAccess() {
    if (!this.objRole.ECHO) {
      this.reset();
      return this.objRole.ECHO == "1" ? true : false;
    } else {
      return this.objRole.ECHO == "1" ? true : false;
    }
  }

  IsWorkshopAccess() {
    if (!this.objRole.WORKSHOP) {
      this.reset();
      return this.objRole.WORKSHOP == "1" ? true : false;
    } else {
      return this.objRole.WORKSHOP == "1" ? true : false;
    }
  }
  IsKitsKiqsAccess() {
    if (!this.objRole.KITS_KIQS) {
      this.reset();
      return this.objRole.KITS_KIQS == "1" ? true : false;
    } else {
      return this.objRole.KITS_KIQS == "1" ? true : false;
    }
  }
  IsPPAccess() {
    if (!this.objRole.PRODUCT) {
      this.reset();
      return this.objRole.PRODUCT == "1" ? true : false;
    } else {
      return this.objRole.PRODUCT == "1" ? true : false;
    }
  }
  IsCTAccess() {
    if (!this.objRole.CLINICAL_TRIALS) {
      this.reset();
      return this.objRole.CLINICAL_TRIALS == "1" ? true : false;
    } else {
      return this.objRole.CLINICAL_TRIALS == "1" ? true : false;
    }
  }
  IsEventsAccess() {
    if (!this.objRole.UPCOMING_EVENTS) {
      this.reset();
      return this.objRole.UPCOMING_EVENTS == "1" ? true : false;
    } else {
      return this.objRole.UPCOMING_EVENTS == "1" ? true : false;
    }
  }
  IsTimelineAccess() {
    if (!this.objRole.TIMELINES) {
      this.reset();
      return this.objRole.TIMELINES == "1" ? true : false;
    } else {
      return this.objRole.TIMELINES == "1" ? true : false;
    }
  }
  IsCongressAccess() {
    if (!this.objRole.CONGRESS) {
      this.reset();
      return this.objRole.CONGRESS == "1" ? true : false;
    } else {
      return this.objRole.CONGRESS == "1" ? true : false;
    }
  }
  IsAtaglanceAccess() {
    if (!this.objRole.AT_A_GLANCE) {
      this.reset();
      return this.objRole.AT_A_GLANCE == "1" ? true : false;
    } else {
      return this.objRole.AT_A_GLANCE == "1" ? true : false;
    }
  }
  IsSMSAccess() {
    if (!this.objRole.SMS) {
      this.reset();
      return this.objRole.SMS == "1" ? true : false;
    } else {
      return this.objRole.SMS == "1" ? true : false;
    }
  }
  getDefaultRedirection() {
    var obj: RoleAccess = JSON.parse(localStorage.getItem('user-data'));
    console.log(obj)
    switch (obj.MYDEFALULT.toString()) {
      case '0':
        {
          return "/dashboard/d3";
        }
      case '1':
        {
          return "/dashboard/AddCapture";
        }
      case '2':
        {
          return "/dashboard/gallery";
        }
      case '3':
        {
          return "/dashboard/upcoming";
        }
      case '4':
        {
          return "/dashboard/news";
        }
      case '5':
        {
          return "/dashboard/report";
        }
      case '6':
        {
          return "/dashboard/congress";
        }
      case '7':
        {
          return "/dashboard/kits";
        }
      case '8':
        {
          return "/dashboard/clinicaltrails";
        }
      case '9':
        {
          return "/dashboard/productprofile";
        }
      case '10':
        {
          return "/dashboard/timelines";
        }
      case '11':
        {
          return "/dashboard/newsletter";
        }
      case '12':
        {
          return "/dashboard/workshop";
        }
      case '13':
        {
          return "/dashboard/ataglance";
        }
      case '14':
        {
          return "/dashboard/echo";
        }
      default: {
        return "/dashboard/d3";
      }
    }
  }
}
export class RoleAccess {
  ROLE: string;
  SECURELVL: string;
  ADMINROLE: string;
  CAPTURE: string;
  GALLERY: string;
  UPCOMING_EVENTS: string;
  NEWS: string;
  REPORTS: string;
  KITS_KIQS: string;
  CONGRESS: string;
  CHAT: string;
  VIEWCHAT: string;
  EXPORT: string;
  MYDEFALULT: string;
  DM: string;
  CONGRESS_ADMIN: string;
  CLINICAL_TRIALS: string;
  PRODUCT: string;
  TIMELINES: string;
  NEWSLETTER: string;
  ECHO: string;
  WORKSHOP: string;
  AT_A_GLANCE: string;
  SMS: string;
}
